import dayjs from "dayjs";

export const columns = [
	{
		header: 'Report name',
		accessorKey: 'name',
		visible: true,
		type: 'string'
	},
	{
		header: 'Email ID',
		accessorKey: 'emails',
		visible: true,
		type: 'custom'
	},
	{
		header: 'Date',
		accessorKey: 'schedule_date',
		visible: true,
		type: 'date'
	},
	{
		header: 'Time',
		accessorKey: 'schedule_time',
		visible: true,
		type: 'time'
	},
	{
		header: 'Recurring',
		accessorKey: 'autopost',
		visible: true,
		type: 'string'
	},
	{
		header: 'Report Page',
		accessorKey: 'report_data.name',
		visible: true,
		type: 'string'
	},
	{
		header: 'Main Page',
		accessorKey: 'main_page',
		visible: true,
		type: 'string'
	},
	{
		header: 'Status',
		accessorKey: 'status',
		visible: true,
		type: 'status'
	},
];
export const formArrayName = 'schedule_report';

export const defaultValues = {
	schedule_report: {
		schedule_date: dayjs(),
		schedule_time: dayjs(),
	}
}

export const apiPayload = {
	type: 'type',
	autopost: (val: any) => val?.is_recurring ? val?.autopost : undefined,
	emails: 'emails',
	id: (value: any) => value?.id || undefined,
	is_recurring: (val: any) => Boolean(val?.is_recurring),
	name: 'name',
	next_schedule_date: 'next_schedule_date',
	schedule_date: 'schedule_date',
	schedule_time: 'schedule_time',
	subject: 'subject',
	report_id: 'report_id',
	filters: (item) => item?.filters || undefined
}
